<div>
  <button
    [id]="'submit-' + id"
    [type]="type"
    type="submit"
    class="submit-button"
    [class]="isGhostButton ? 'ghost' : ''"
    (click)="submit()"
    [disabled]="disabled"
  >
    {{ labelKey | i18next }}
  </button>
</div>
